import lesson from "./lesson";
import userlesson from "./userlesson";
import quiz from "./quiz";
import lessonvideo from "./lessonvideo";
import faq from "./faq";

export default {
  namespaced: true,
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {

  },
  modules: {
    lesson,
    userlesson,
    quiz,
    lessonvideo,
    faq
  },
};
